import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';

export default function ImportDialog(props) {
    const classes = useStyles();
    return <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogContent dividers>
                    <div className={classes.dialog}>
                        <Typography className={classes.importText}>{props.filename}</Typography>
                        <PublishOutlinedIcon className={classes.importIcon}></PublishOutlinedIcon>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus variant="outlined" onClick={props.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button className={classes.importButton} variant="contained" onClick={props.handleImport} color="primary">
                        Import
                    </Button>
                </DialogActions>
            </Dialog>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'  
      },
  
      paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
      },

      dialog: {
          width: "400px",
          padding: "60px",
          height: "275px",
          justifyContent: "center",
          textAlign: "center"
      },

      importIcon: {
          fontSize: "200pt",
          color: "gray"
      },

      importText: {
          fontSize: "20pt"
      },

      importButton: {
          backgroundColor: "#5CC958 !important"
      }
});